import React, { useEffect, useState } from "react";
import { MessageSquareText, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 400;
      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200;
      setVisible(past && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const smsHref = `sms:${BUSINESS.phoneHref.replace("tel:", "")}?body=${encodeURIComponent(
    "Hi Spotless Water Works, I'd like a quote for "
  )}`;

  return (
    <div
      className={`md:hidden fixed z-50 bottom-5 left-5 right-5 flex items-stretch gap-3 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-8 pointer-events-none"
      }`}
      data-testid="mobile-sticky-cta-wrap"
    >
      <a
        href="#contact"
        className="flex-1 h-14 rounded-full bg-[#C4FF00] text-black font-bold uppercase tracking-widest text-sm flex items-center justify-center gap-2 shadow-[0_10px_40px_rgba(196,255,0,0.35)]"
        data-testid="mobile-sticky-cta"
        aria-label="Get a free quote"
      >
        <MessageSquareText className="h-5 w-5" />
        Get Quote
      </a>
      <a
        href={smsHref}
        className="h-14 w-14 shrink-0 rounded-full bg-[#00BFFF] text-black grid place-items-center shadow-[0_10px_40px_rgba(0,191,255,0.4)]"
        data-testid="mobile-sticky-sms"
        aria-label="Text us"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
    </div>
  );
}
